import React from 'react';
import { FormattedMessage } from 'react-intl';

export const ALERT_SEVERITY = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
};

export const OVERRIDE_STYLE = {
  NSR: {
    color: '#000000',
    backgroundColor: '#9DD3DE',
    'margin-bottom': '10px',
  },
};

export const ALERT_MSG = {
  ENROLLMENT: <FormattedMessage id="alert.profile_updated" />,
  ORDER_CREATION: <FormattedMessage id="alert.profile_updated" />,
  NSR_INFO: <FormattedMessage id="alert.message.nsr_info" />,
  EKG_INTERPRETATION: <FormattedMessage id="alert.ekg_reviewed" />,
  PROFILE_UPDATE: <FormattedMessage id="alert.profile_updated" />,
  QT_UPDATE: <FormattedMessage id="alert.qt_updated" />,
  EKG_INTERPRETATION_AND_QT_UPDATE: (
    <FormattedMessage id="alert.ekg_reviewed_and_qt_updated" />
  ),
};

export const ESIGN_MODAL_NAME = {
  ENROLLMENT: 'ENROLLMENT',
  ORDER_CREATION: 'ORDER_CREATION',
  EKG_INTERPRETATION: 'EKG_INTERPRETATION',
  PROFILE_UPDATE: 'PROFILE_UPDATE',
  QT_UPDATE: 'QT_UPDATE',
  EKG_INTERPRETATION_AND_QT_UPDATE: 'EKG_INTERPRETATION_AND_QT_UPDATE',
};

export const ALERT_STYLE = {
  SUCCESS: {
    backgroundColor: '#067F6F',
  },
  WARNING: {},
  ERROR: {},
  INFO: {},
};



// WEBPACK FOOTER //
// ./src/views/components/Common/AlertBar/Constants.js